import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PRODUCTS = [
  {
    name: "Guardian",
    lookupKey: "guardian_50ml",
    price: "£25",
    preorder: false,
    image: "/images/product-guardian.png",
    alt: "TABI Guardian eau de parfum with oud wood, amber and vanilla",
    notes: ["Oud Wood", "Smoky Woods", "Amber", "Spices", "Vanilla", "Dark Botanicals"],
    description:
      "Deep oud and smoky woods wrapped in golden amber, dark spices and soft vanilla — steadfast, grounding, quietly powerful. For the ones who protect what they love.",
  },
  {
    name: "Legacy",
    lookupKey: "legacy_50ml",
    price: "£25",
    preorder: false,
    image: "/images/product-legacy.png",
    alt: "TABI Legacy eau de parfum surrounded by roses, peonies and lychee",
    notes: ["Rose", "Peony", "Lychee", "Rhubarb", "Vanilla"],
    description:
      "Velvet rose and peony brightened by lychee and rhubarb, resting on warm vanilla — luminous, lasting, unforgettable. For the stories that deserve to be carried forward.",
  },
  {
    name: "Guardian & Legacy",
    slug: "duo",
    lookupKey: "bundle_duo",
    price: "£40",
    preorder: false,
    subtitle: "2 x Eau de Parfum · 50ml",
    image: "/images/craft-perfumes.png",
    alt: "The TABI duo bundle — Guardian and Legacy 50ml eau de parfums together",
    notes: ["Guardian 50ml", "Legacy 50ml", "Save £10"],
    description:
      "The complete first chapter: Guardian and Legacy together. Two scents, one legacy — strength and story, side by side. Welcome both home and save £10.",
  },
];

export async function startCheckout(lookupKey) {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key: lookupKey,
    quantity: 1,
    origin_url: window.location.origin,
  });
  window.location.href = data.checkout_url;
}

export async function getInventory() {
  const { data } = await axios.get(`${API}/inventory`);
  return data;
}

export function checkoutError(soldOut = false) {
  toast.error(soldOut ? "Sorry — this fragrance has just sold out." : "Could not open checkout. Please try again.");
}
